import { render } from "./TrueFalse.vue?vue&type=template&id=d4bf318e"
import script from "./TrueFalse.vue?vue&type=script&lang=js"
export * from "./TrueFalse.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__